@if(spinnerService.spinnerVisible || spinnerService.deletedItemId!==-1) {
<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
</span>
}